import { makeStyles } from "tss-react/mui";

export const useDefaultStyles = makeStyles()(() => ({
  cursorPointer: {
    cursor: "pointer",
  },
  textWrap: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));
